import groq from 'groq';

import { PRODUCT_SLUG } from './productSlug';

/* INFO: Builds the PDP href for the product based on it's category ie:
 *
 * /products/mitopure-gummies
 * /skincare/products/firming-serum
 *
 * This can be used in different contexts so if queries a product ref the
 * parentSelector would be 'product->'. */

export const productHref = (parentSelector?: string) => {
  const selector = parentSelector ? `${parentSelector}` : '';

  return groq`
  "href": select(
    ${selector}category == "skincare" => "/skincare/products/" + ${selector}{ ${PRODUCT_SLUG} }.slug,
    "/products/" + ${selector}{ ${PRODUCT_SLUG} }.slug
  )
`;
};
